import request from '@/utils/request'

export function bidList(data) {
  return request({
    url: '/bid/list',
    method: 'get',
    params: data
  })
}
export function bidTime(data) {
  return request({
    url: '/bid/time',
    method: 'get',
    params: data
  })
}
